import logo from "../images/buddy_and_selly-logo-white.svg";

// Header and footer for the standalone portal. VITE EN VOGUE embeds the page
// in its own furniture and passes chrome: "bare", which skips this entirely.
export default function SiteChrome({ contact, year, children }) {
  const tel = contact.phone.replace(/[ ()-]/g, "");
  return (
    <>
      <div className="header-wrapper">
        <div className="header expanded" role="banner">
          <div>
            <img src={logo} alt="Buddy & Selly" />
            <ul>
              <li className="hotline">
                <a href={`tel:${tel}`} rel="noopener" title={contact.callUs}>
                  <span>{contact.callUs}</span> {contact.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container first-on-page" role="main">
        {children}
      </div>
      <footer className="center-text" role="contentinfo">
        <div className="container footer-inline-section">
          <ul className="gr-12">
            <li>
              {contact.writeUs}{" "}
              <a href={`mailto:${contact.email}`} rel="noopener">
                {contact.email}
              </a>
            </li>
            <li>© Reverse-Retail GmbH {year}</li>
          </ul>
        </div>
      </footer>
    </>
  );
}
